import { Route } from "react-router-dom";
import { BuildingDetailsPage } from "./BuildingDetailsPage";
import {
  BuildingDetailsPageErrorBoundary,
  BuildingDetailsPageLoader,
} from "./BuildingDetailsPage/loaders";
import { ProtectedRoute } from "~/context/ProtectedRoute";
import * as APITypes from "~/API";
import { ROUTES } from "~/utils";

export const BuildingPagesRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES.buildingDetails}
        loader={BuildingDetailsPageLoader}
        ErrorBoundary={BuildingDetailsPageErrorBoundary}
        element={
          <ProtectedRoute
            roles={[
              APITypes.TenantStatusType.Active,
              APITypes.TenantStatusType.InActive,
            ]}
          >
            <BuildingDetailsPage />
          </ProtectedRoute>
        }
      />
    </>
  );
};
